import { FormControlLabel, Switch } from '@mui/material';
import { AutoCompleteHierarchicalModel } from 'components/MprcAutoCompleteHierarchical';
import { UnitAutoCompleteHierarchicalModel } from 'components/MprcAutoCompleteHierarchical/AutoCompleteHierarchicalModel';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UnitAutoCompleteHierarchical } from 'views/foundation/unit/components/UnitAutoCompleteHierarchical';

////////////////////////////////////////////////////////////////////////////

interface IProps {
    onError: (e: any) => void;
    onItemsChange: (members: string[]) => void;
    unitTypeId?: string;
}

////////////////////////////////////////////////////////////////////////////

export const AddUnit: React.FC<IProps> = (props) => {

    const { unitTypeId, onItemsChange, onError } = props;
    const { t } = useTranslation("knowledge");

    const [selectedUnit, setSelectedUnit] = useState<UnitAutoCompleteHierarchicalModel>();
    const [includeDescendants, setIncludeDescendants] = useState<boolean>(false);

    ////////////////////////////////////////////////////////////////////////////
    ///
    const onChange = (item: (AutoCompleteHierarchicalModel | UnitAutoCompleteHierarchicalModel)[]): void => {
        if (item.length > 0) {
            setSelectedUnit(item[0] as UnitAutoCompleteHierarchicalModel);
        }
        else {
            setSelectedUnit(undefined);
        }
    };

    ////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        onItemsChange(selectedUnit != undefined ? (includeDescendants ? [selectedUnit!.allUsersGroup.id] : [selectedUnit!.usersGroup.id]) : []);
    }, [selectedUnit, includeDescendants]);

    return (<>
        <UnitAutoCompleteHierarchical
            autoFocus
            selectedItems={selectedUnit != undefined ? [selectedUnit] : []}
            multiSelect={false}
            selectedMode={'free'}
            unitTypeId={unitTypeId}
            onChange={onChange}
            onError={onError}
            helperText={t("Channel.Edit.Members.SelectUnitHint")}
            placeholder={t("Channel.Edit.Members.SelectUnitPlaceholder")}

        />

        <FormControlLabel label={t("Channel.Edit.Members.IncludeDescendantsLabel")}
            control={<Switch checked={includeDescendants} onChange={() => setIncludeDescendants(!includeDescendants)} />}
        />
    </>);
};
